<!-- @author linhui.zhang  -->
<template>
  <div
    id="print"
    :class="['training', 'training-blockly-content', { mark: beMark }]"
  >
    <base-editor-head
      :project-id="projectId"
      :editor-id="editorId"
      :Project.sync="Project"
      @saveFile="saveFile"
      @onExecution="onExecution"
    ></base-editor-head>
    <div class="training-area">
      <!-- :运行区模块  -->
      <div class="training-right-side">
        <base-code-run
          :codeText="codeText"
          @runHandle="runHandle"
          @sidebarSwitchHandle="sidebarSwitchHandle"
          :Project.sync="Project"
          :project-id="projectId"
          ref="codeRun"
          v-bind="$attrs"
          v-on="$listeners"
        />
      </div>
      <base-block-index
        :project-id="projectId"
        :training-id="trainingId"
        :blockXmlText="blockXmlText"
        :xml-data="{
          name: Project.projectName,
          type: 1,
          path: Project.blocksFileUrl,
        }"
        :save-flag="saveFlag"
        ref="blocklyIndex"
        />
    </div>
    <!-- <block- -->
    <div class="popup-list popup-list3">
      <!-- 不创建项目提示：继续创建在本页面，取消则退回上一页-->
      <gat-popup
        :class="['popup-execution', popupActive === 'execution' ? 'on' : 'off']"
        :title="''"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="executionProject"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span class="title">是否退出新建项目？</span>
            </div>

            <div class="content">确定退出将返回首页</div>
          </div>
        </template>
      </gat-popup>
      <!-- 离开时保存提示弹框 -->
      <gat-popup
        :class="[
          'popup-leave-save',
          popupActive === 'leave-save' ? 'on' : 'off',
        ]"
        :title="'是否保存项目？'"
        :primary-button="'确定'"
        :cancel-button="'否'"
        @cancel="confirmLeaveSave"
        @confirm="confirmLeaveSave(true)"
      >
        <template v-slot:content>
          <span></span>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import BaseEditorHead from '@/views/projects/baseBlockEditor/components/BaseEditorHead.vue'
import BaseBlockIndex from '@/components/baseBlockEditor/BaseBlockIndex.vue'
import AIBLOCK from '@/axios/personalSpace/AiEditor/blocks.js'
import PERSONAL from '@/axios/personalSpace/personalSpace.js'
import BaseCodeRun from '@/components/baseBlockEditor/common/BaseCodeRun.vue'
import GatPopup from '@/components/common/GatPopup'
import { mapGetters } from 'vuex'
import bus from '@/utils/bus'
import {debounce} from 'lodash'
export default {
  name: 'BaseBlockEditorHome',
  components: { BaseEditorHead, BaseBlockIndex, GatPopup, BaseCodeRun },
  props: ['trainingId', 'createBy'],
  data() {
    return {
      Blocks: { TotalCount: 0, Items: [] },
      projectId: '',
      editorId:'',
      workspaceIsVisible: true,
      homeWorkStatus: false,
      beMark: false, //遮罩层
      Project: {
        //项目信息存储
        projectId: '00000000-0000-0000-0000-000000000000',
        projectName: '',
        blocksFileUrl: '',
      },
      blockXmlText: '',
      // 边框开关
      sidebarSwitch: true,
      popupActive: '',
      saveFlag: 0, // 保存后没有修改，或打开后没有修改
      leaveType: '', //跳转的路由来源
      codeText: '', //运行结果，在runCode组件中处理;
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
        },
      },
    }
  },
  provide() {
    return {
      blockSData: this.Blocks,
    }
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(['accountInfo', 'hasRunSuccess', 'curriculumId','userRole']),
  },
  //监控data中的数据变化
  watch: {},

  async created() {
    let self = this
    let query = this.$route.query
    if (query ) {
      //全局变量，判断是否为老师角色从评分进来
      this.projectId = query.projectId
      this.editorId = query.editorId
      this.$store.state.blocklyHome.createBy= query.createBy
    }

    //离开前监听
    bus.$on('beforeLeave', async (type) => {
      self.leaveType = type
      self.beforeLeave()
    })
    //监听 转换 代码模式/积木模式
    // bus.$on("changeMode", () => {
    //   //在EditorIndex.vue处理保存项目功能;
    //   self.changeMode();
    // });


    //监听 显示积木工作区
    bus.$on('changeWorkspace', (val) => {
      self.workspaceIsVisible = val
    })
  },

   mounted() {
    this.homeWorkStatus = this.$store.state.blocklyHome.homeWorkStatus
  //获取项目
    this.getProjectByProjectId()
  },
  beforeDestroy() {
    this.$store.state.blocklyHome.hasRunSuccess = null
    bus.$off('changeRightSide')
    bus.$off('changeWorkspace')
  },
  methods: {
    // 判断是否移动端设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
    // 移动端设置横屏
    mobileEngines() {
      var width = document.documentElement.clientWidth
      var height = document.documentElement.clientHeight
      if (width < height) {
        let print = document.querySelector('#print')
        // print.style['width'] = height + 'px'
        // print.style['height'] = width + 'px'
        // print.style['top'] = (height - width) / 2 + 'px'
        // print.style['left'] = (0 - (height-width) / 2 ) + 'px'
        // print.style['transform'] = 'rotate(90deg)'
        // print.style['transform-origin'] = '50% 50%'
        print.style.width = height + 'px'
        print.style.height = width + 'px'
        print.style.top = ((height - width) / 2) + 'px'
        print.style.left = (0 - (height - width) / 2) + 'px'
        print.style.transform = 'rotate(90deg)'
        print.style.transformOrigin = '50% 50%'
      }

      var evt = 'onorientationchange' in window ? 'orientationchange' : 'resize'
      window.addEventListener(
        evt,
        function() {
          var width = document.documentElement.clientWidth
          var height = document.documentElement.clientHeight
          let print = document.querySelector('#print')
          if (width > height) {
            print.style.width = width + 'px'
            print.style.height = height + 'px'
            print.style.top = 0
            print.style.left = 0
            print.style.transform = 'none'
            print.style.transformOrigin = '50% 50%'
          } else {
            print.style.width = height + 'px'
            print.style.height = width + 'px'
            print.style.top = ((height - width) / 2) + 'px'
            print.style.left = (0 - (height - width) / 2) + 'px'
            print.style.transform = 'rotate(90deg)'
            print.style.transformOrigin = '50% 50%'
          }
        },
        false
      )
    },
    beforeLeave() {
      let self = this
      this.popupActive = 'leave-save'
    },
    leavePage(data) {
      let deleteTrainingId,
        trainingId = this.trainingId
      if (!data || !data.deleteTrainingId) {
        return
      }
      deleteTrainingId = data.deleteTrainingId
      if (deleteTrainingId === trainingId && this.userRole === 2) {
        this.$message.warning('该课程实训已被撤回或删除，页面将5s后退出')
        setTimeout(() => {
          this.confirmLeaveSave(false)
        }, 5000)
      }
    },
    async confirmLeaveSave(val) {
      let leaveType = this.leaveType
      let editorId = this.editorId
      // 点击删除按钮时，不退出页面，弹框消失；
      if (!val||val === 'firstOff') {
        return (this.popupActive = '')
      }
      if (val === true) {
        let result = await this.saveFile() //保存项目
      }
      //退出操作
      switch (leaveType) {
        case 'back': {
          this.$router.push({
             name: 'projects-list',
            query: { editorId },
          })
          // this.$router.go(-1);
          break
        }
        default: {
          this.$router.push('/')
          break
        }
      }

      this.leaveType = ''
      this.popupActive = ''
    },
    // 退出提示弹窗
    onExecution() {
      this.popupActive = 'execution'
    },
    // 退出提示确认
    //防抖函数
    executionProject:debounce(function(type){
      // this.$router.go(-1)
      this.$router.push({name: 'home'});
    }, 300),
    // 取消弹窗
    cancelPopup(val) {
      this.popupActive = ''
      this.scoreForm = ''
    },

    //获取积木列表接口
    async getBlockList() {
      let res = await AIBLOCK.getBlockList()
      if (res.isSuccess) {
        var Blocks = this.Blocks
        Blocks.TotalCount = res.data.length
        Blocks.Items = res.data
        this.Blocks = Blocks
      }
      return res
    },
    /**
    获取个人空间项目详情数据 @data projectId
  */
    async getProjectByProjectId() {
      let res,
        data = {
          projectId: this.projectId,
        }

      res = await PERSONAL.getProjectByProjectId(data)
      if (res.isSuccess) {
        try {
          this.blockXmlText = res.data.buildingBlocks
          this.Project = res.data
        } catch (e) { console.log(e)}
      }
      return res
    },

    //保存项目文件功能 runType 保存或者是另存为，显示提示不一样
     saveFile:debounce(async function(id) {
      if (!this.projectId) return

      var xml = this.$refs.blocklyIndex.$refs.blockly.workspaceToDom(), //工作台上的积木
        projectId = id || this.projectId,
        data = {},
        result,
        msg = id ? '保存成功' : '保存成功',
        pythonCodeText = this.codeText

      data = {
        buildingBlocks: xml.outerHTML,
        projectId,
      }
      result = await PERSONAL.saveProjectCode(data)
      if (result && result.isSuccess) {
        this.$message.success(result.returnMsg)
      } else if (result) {
        this.$message.error(result.returnMsg)
      }
      return result
    },1500),
    
    runHandle() {
      this.$refs.blocklyIndex.$refs.blockly.runHandle()
    },

    // UI rating star
    UIRatingStarshow(idx, rate) {
      let result = ''
      if (rate - idx >= 1) {
        result = 'icon-star-entire'
      } else if (rate - idx >= 0.5) {
        result = 'icon-star-half'
      }
      return result
    },
    // 重绘工作区大小
    sidebarSwitchHandle(switchObj) {
      this.sidebarSwitch = switchObj.sidebarSwitch
      bus.$emit("onSidebarSwitch");
      // if (window) {
      //   this.$nextTick(() => {
      //     // window.dispatchEvent(new Event("resize"));
      //     var resizeEvent = window.document.createEvent('UIEvents')
      //     resizeEvent.initUIEvent('resize', true, false, window, 0)
      //     window.dispatchEvent(resizeEvent)
      //   })
      // }
    },
  },
  updated() {}, //生命周期 - 更新之后
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
@import './BaseBlockEditorHome.scss';

</style>
